module.exports = new __parcel__URL__("Lobby1.7c1d9175.hdr").toString();